module.exports = __webpack_public_path__ + "img/banner_1.a27e9e42.png";